<template>
<div>
    <div class="col-md-12 flex-between-row">
        <div class="col-md-6">
            <h3 class="page-header"><i class="fa fa fa-user-md animated bounceInDown show-info"></i> View Pending Complaints</h3>
        </div>
        <div class="col-md-6 text-r">
            <button class="btn btn-primary" @click="refresh()"><i class="fa fa-refresh"></i> Referesh</button>
        </div>
    </div>
    <div class="complaint-summary" v-if="summary">
        <span class="complaint-summary-period" v-if="summary.entrydatefrom">
            <i class="fa fa-calendar"></i> {{ formatDate(summary.entrydatefrom) }} to {{ formatDate(summary.entrydateto) }}
        </span>
        <span class="complaint-summary-item">Total Complaints <strong>{{ summary.total }}</strong></span>
        <span class="complaint-summary-item complaint-summary-resolved">Total Resolved <strong>{{ summary.resolved }}</strong></span>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="panel panel-cascade">

                 <div class="panel-body ">             
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-horizontal cascde-forms">

                                <div class="form-group flex-row CHK">
                                    <label class="col-lg-4 col-md-3 control-label">Customer Name</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="customername" type="text" value="" />
                                    </div>
                                </div>
                                <!-- <div class="form-group flex-row CHK">
                                    <label class="col-lg-4 col-md-3 control-label">Address</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="customername" type="text" value="" />
                                    </div>
                                </div> -->
                                
                                <div class="form-group flex-row">
                                    <label class="col-lg-4 col-md-3 control-label">Entry Date : FROM</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="entrydatefrom" type="date"  />
                                    </div>
                                </div>
                                <div class="form-group flex-row">
                                    <label class="col-lg-4 col-md-3 control-label">Dispose Date : FROM</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="disposedatefrom" type="date" />
                                    </div>
                                </div>
                                <div class="form-group flex-row">
                                    <label class="col-lg-4 col-md-3 control-label">Schedule Date : FROM</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="scheduledatefrom" type="date" />
                                    </div>
                                </div>
                                <div class="form-group flex-row" style="display:none">
                                    <label class="col-lg-4 col-md-3 control-label">Status</label>
                                    <div class="col-lg-8 col-md-9">
                                        <select class="form-control form-cascade-control input-small" v-model="isdispose"><option value="0">SELECT</option>
                                            <option value="0">PENDING</option>
                                            <option value="1">DISPOSE</option>
                                        </select>
                                    </div>
                                </div>
                                <!-- <div class="form-group flex-row" v-if="loggedinuser?.role<2">
                                    <label class="col-lg-4 col-md-3 control-label">Followed By 12</label>
                                    <div class="col-lg-8 col-md-9">
                                        <select v-model="followbyid" class="form-control form-cascade-control input-small">
                                            <option v-for="filter in employees.filter(property => property.id ==loggedinuser.id )" :key="filter.id" :value="filter.id" ><span >{{filter.name}}</span></option>
                                        </select>             
                                    </div>
                                </div> -->
                                <div class="form-group flex-row">
                                    <label class="col-lg-4 col-md-3 control-label">Complaint No.</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="complaintno" type="number" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 CHK">
                            <div class="form-horizontal cascde-forms">
                                <div class="form-group flex-row CHK">
                                    <label class="col-lg-4 col-md-3 control-label">Customer Mobile</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="customermobile" type="number"/>
                                    </div>
                                </div>
                               
                                <div class="form-group flex-row">
                                    <label class="col-lg-4 col-md-3 control-label">Entry Date : TO</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="entrydateto" type="date" :min="entrydatefrom" :max="entrydatefrom ? maxRangeEnd(entrydatefrom) : ''" />
                                    </div>
                                </div>
                                <div class="form-group flex-row">
                                    <label class="col-lg-4 col-md-3 control-label">Dispose Date : TO</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="disposedateto" type="date" :min="disposedatefrom" :max="disposedatefrom ? maxRangeEnd(disposedatefrom) : ''" />
                                    </div>
                                </div>
                                <div class="form-group flex-row">
                                    <label class="col-lg-4 col-md-3 control-label">Schedule Date : TO</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="scheduledateto" type="date" :min="scheduledatefrom" :max="scheduledatefrom ? maxRangeEnd(scheduledatefrom) : ''" value="" />
                                    </div>
                                </div>
                                
                                <div class="form-group flex-row">
                                    <label class="col-lg-4 col-md-3 control-label">Entry By</label>
                                    <div class="col-lg-8 col-md-9">
                                        <select v-model="entrybyid" class="form-control form-cascade-control input-small">
                                            <option v-for="filter in employees" :key="filter.id" :value="filter.id">{{filter?.name}}</option>
                                        </select>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group flex-row">
                            <div class="col-md-9" style="">
                                <input type="submit" @click="search()" value="Search" class="btn bg-primary text-white btn-md">
                            </div>
                            <div class="col-md-3" style="">
                                <input type="submit" @click="initial()" value="Clear" class="btn bg-danger text-white btn-md">
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </div>
    <div class="complaint-highlights" aria-label="Complaint status highlights">
        <button v-for="box in highlightBoxes" :key="box.key" type="button"
            :class="['complaint-highlight', 'complaint-highlight-' + box.key, {active: selectedHighlight === box.key, dimmed: selectedHighlight && selectedHighlight !== box.key}]"
            :aria-pressed="selectedHighlight === box.key"
            @click="toggleHighlight(box.key)">
            <span>{{ box.label }}</span><strong>{{ complaintHighlights[box.key] }}</strong>
        </button>
    </div>
    <div class="complaint-filter-note" v-if="selectedHighlight">
        Showing {{ filteredLeads.length }} {{ selectedHighlightLabel }} complaint(s).
        <a href="#" @click.prevent="selectedHighlight = ''">Show all</a>
    </div>
    <div class="table-responsive">
        <div class="panel">
            <div class="panel-body" style="overflow-x:auto;padding-left:0px">
                <table class="table users-table table-condensed table-hover table-bordered table-sm">
                    <thead class="table-font" style="font-size:13px;">
                        <tr>
                            <th>#</th>
                            <th>Vsdigi ID</th>
                            <th class="visible-lg">NAME</th>
                            <th>MOBILE</th> 
                            <th>ADDRESS</th>
                            <th>Complaint No.</th>
                            <th>Complaint Description</th>
                            <th>DATE OF PURCHASE</th>
                            <th>PRODUCT</th>
                            <th>SCHEDULED DATE</th>
                            <th>ENTRY BY<br>ENTRY DATE</th>
                            <th>Status</th>
                            <th>ACTION</th>
                            <th>FALLOW BY</th>
                        </tr>
                    </thead>
                    <pending-row v-for="(item,index) in filteredLeads" :key="item.id" :item="item" :index="index"></pending-row>
                </table>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import PendingRow from './PendingRow.vue'
import { maxRangeEnd, rangeError, toDateString } from './complaintDates'
export default {
    components: { PendingRow },
    data() {
        return {
            // leads:[],
            customername:'',
            customermobile:'',
            followbyid:0,
            entrydatefrom:'',
            disposedatefrom:'',
            requesttype:2,
            scheduledatefrom:'',
            entrybyid:0,
            disposedateto:'',
            entrydateto:'',
            scheduledateto:'',
            leadtype:0,
            isdispose:0,
            complaintno:'',
            rows:0,
            summary:null,
            selectedHighlight:'',
            highlightBoxes:[
                {key:'launched', label:'Launched'},
                {key:'scheduled', label:'Scheduled'},
                {key:'resolved', label:'Resolved'},
                {key:'cancelled', label:'Cancelled'},
                {key:'overdue', label:'Overdue'},
            ]
        }
    },
    mounted() {
        this.refresh();
    },
    computed:{
        ...mapGetters(['leads','loggedinuser']),
        employees(){
            if(this.$store.getters.employees.length == 0){
                console.log("employees")
                this.$store.dispatch("fetchemployees")
            }
            return this.$store.getters.employees
        },
        complaintHighlights(){
            const counts = {launched: 0, scheduled: 0, resolved: 0, cancelled: 0, overdue: 0}
            ;(this.leads || []).forEach(item => {
                const status = this.complaintStatus(item)
                if (Object.prototype.hasOwnProperty.call(counts, status)) counts[status] += 1
                if (this.isOverdue(item)) counts.overdue += 1
            })
            return counts
        },
        filteredLeads(){
            const leads = this.leads || []
            if (!this.selectedHighlight) return leads
            if (this.selectedHighlight === 'overdue') return leads.filter(item => this.isOverdue(item))
            return leads.filter(item => this.complaintStatus(item) === this.selectedHighlight)
        },
        selectedHighlightLabel(){
            const box = this.highlightBoxes.find(b => b.key === this.selectedHighlight)
            return box ? box.label.toLowerCase() : ''
        }
    },
    methods: {
        maxRangeEnd,
        toggleHighlight(key){
            this.selectedHighlight = this.selectedHighlight === key ? '' : key
        },
        // Scheduled for a day already gone and still open.
        isOverdue(item){
            const status = this.complaintStatus(item)
            if (!item.scheduledate || ['resolved', 'cancelled', 'disposed'].includes(status)) return false
            return String(item.scheduledate).slice(0, 10) < toDateString(new Date())
        },
        formatDate(value){
            if (!value) return ''
            const [y, m, d] = String(value).slice(0, 10).split('-')
            return `${d}-${m}-${y}`
        },
        complaintStatus(item){
            if (item?.complaint_status) return item.complaint_status
            if (item?.isdispose == 1) return 'disposed'
            if (item?.iscancelled == 1) return 'cancelled'
            if (item?.status == 1) return 'resolved'
            return item?.scheduledate ? 'scheduled' : 'launched'
        },
        refresh(){
            this.initial()
            // this.$store.dispatch("fetchemployees")
            this.$store.dispatch("fetchattributes")
            this.search()
        },
        search(){
            const error = rangeError(this.entrydatefrom, this.entrydateto, 'Entry')
                || rangeError(this.disposedatefrom, this.disposedateto, 'Dispose')
                || rangeError(this.scheduledatefrom, this.scheduledateto, 'Schedule')
            if (error) {
                this.$notify({text:error,type:'error'})
                return
            }
            let param = {isdispose:0,
                noofrec:1000,
                customername:this.customername,
                customermobile:this.customermobile,
                followbyid:this.followbyid,
                entrydatefrom:this.entrydatefrom,
                disposedatefrom:this.disposedatefrom,
                requesttype:2,
                scheduledatefrom:this.scheduledatefrom,
                entrybyid:this.entrybyid,
                disposedateto:this.disposedateto,
                entrydateto:this.entrydateto,
                scheduledateto:this.scheduledateto,
                complaintno:this.complaintno,
                leadtype:this.leadtype}
            this.$store.commit('assignloadingstatus',1)
            this.$http.post('api/vsdigi/complaints/fetch/all',param)
            .then((response) => this.processLeadResponse(response.data))
            .catch((err) => {
                console.log(err)
                this.$store.commit('assignloadingstatus',0)
                this.$notify({text:err?.response?.data?.message || 'Could not load complaints',type:'error'})
            });
        },
        processLeadResponse(data){
            this.$store.commit('assignloadingstatus',0)
            const leads = [...(data.lead || [])].sort((a, b) => {
                const first = a.created_at ? new Date(a.created_at).getTime() : Number.POSITIVE_INFINITY
                const second = b.created_at ? new Date(b.created_at).getTime() : Number.POSITIVE_INFINITY
                return first - second
            })
            this.$store.commit("assignleads", leads)
            this.rows=data.count
            this.summary=data.summary || null
        },

        initial(){
            this.customername=''
            this.customermobile=''
            this.followbyid=0,
            this.entrydatefrom=''
            this.disposedatefrom=''
            this.scheduledatefrom=''
            this.entrybyid=0
            this.disposedateto=''
            this.entrydateto=''
            this.selectedHighlight=''
            this.scheduledateto=''
            this.leadtype=0
            this.isdispose=0
            this.complaintno=''
        }
    },
}
</script>
<style>
.flex-row{
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
    flex-wrap: wrap;
}
.complaint-highlights{
    display:flex;
    flex-wrap:wrap;
    gap:12px;
    margin:0 0 16px;
}
.complaint-highlight{
    flex:1 1 150px;
    min-width:140px;
    padding:12px 16px;
    border:0;
    border-radius:4px;
    color:#fff;
    text-align:left;
    cursor:pointer;
    box-shadow:0 1px 4px rgba(0,0,0,.12);
    transition:opacity .15s, transform .15s, box-shadow .15s;
}
.complaint-highlight:hover{transform:translateY(-1px);box-shadow:0 3px 8px rgba(0,0,0,.2)}
.complaint-highlight.active{box-shadow:0 0 0 3px #fff, 0 0 0 5px #333}
.complaint-highlight.dimmed{opacity:.5}
.complaint-highlight span,
.complaint-highlight strong{display:block}
.complaint-highlight strong{font-size:24px;line-height:1.2;margin-top:4px}
.complaint-highlight-launched{background:#6f42c1}
.complaint-highlight-scheduled{background:#0d6efd}
.complaint-highlight-resolved{background:#198754}
.complaint-highlight-cancelled{background:#dc3545}
.complaint-highlight-overdue{background:#fd7e14}
.complaint-filter-note{margin:-8px 0 12px;font-size:13px}
.complaint-summary{
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    gap:12px 24px;
    margin:0 15px 12px;
    padding:10px 16px;
    border-radius:4px;
    background:#f5f7fa;
    border:1px solid #e1e5eb;
}
.complaint-summary-period{color:#555}
.complaint-summary-item strong{font-size:20px;margin-left:6px}
.complaint-summary-resolved strong{color:#198754}
</style>
